import { queryOptions, useQuery } from "@tanstack/react-query";

import type { DataSource } from "~/data-sources/types/data-source";
import type { GetDataSourcesParams } from "~/data-sources/api/get-data-sources";

function getDataSourcesQueryOptions(params: GetDataSourcesParams) {
  return queryOptions({
    queryKey: ["workspace", "data-sources", params],
    enabled: typeof params.workspaceId !== "undefined",
    async queryFn() {
      /**
       * There's an issue that doing health-checks on the server
       * are failing due to unknown reasons, for ex. atlassian returns Unauthorized
       * if used in a server action, and azure returns 203 instead of 200
       * Could potentially be issues due to headers, origin?
       */
      if (typeof window === "undefined") {
        return [];
      }

      const endpoint = new URL("/api/data-sources", location.origin);
      endpoint.searchParams.set("workspaceId", String(params.workspaceId));
      const response = await fetch(endpoint);

      return response.json() as Promise<DataSource[]>;
    },
  });
}

function useDataSources<TSelect = DataSource[]>(
  params: GetDataSourcesParams,
  select?: (data: DataSource[]) => TSelect,
) {
  return useQuery({
    ...getDataSourcesQueryOptions(params),
    select,
  });
}

export { getDataSourcesQueryOptions, useDataSources };
